import { addInShapeList, generateArrow, minimumArrowSize } from "../../components/Markup/MarkupFunction";
import reduxStore from "../../configureEnvStore";
import { COLOR_TO_ANNOT, shapeStatus } from "../../constants/Constants";
import { MOUSE_EVENTS, uploadMarkupRootScope } from "../../constants/MarkupConstants";
import { UPLOAD_FILES_DATA } from "../../constants/UploadFilesConstants";
import UploadFileMarkupService from "./UploadFileMarkupService";

class ArrowShapeService {
    arrowDrawing = (type, o) => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (type === MOUSE_EVENTS.DOWN) {
            //for select and move
            if (annCanvas.findTarget(o.e)) {
                if (annCanvas.findTarget(o.e).localShape == true) {
                    return;
                } // return to select and move if current state
            }
            //required to set
            uploadMarkupRootScope.isResetted = false;
            UploadFileMarkupService.pointer = annCanvas.getPointer(o.e);
            UploadFileMarkupService.isMovingArrow = false;
            UploadFileMarkupService.isDrawingArrow = true;
            UploadFileMarkupService.origX = UploadFileMarkupService.pointer.x;
            UploadFileMarkupService.origY = UploadFileMarkupService.pointer.y;
            let mouseDownGenerateArrowFeatures = {
                fromx: UploadFileMarkupService.origX,
                fromy: UploadFileMarkupService.origY,
                tox: UploadFileMarkupService.pointer.x,
                toy: UploadFileMarkupService.pointer.y,
                color: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                strokeWidth: reduxStore.getState().markup.selectedThicknessForShape,
                isShadow: reduxStore.getState().markup.isShadowOrStroke,
            };
            UploadFileMarkupService.arrowObj = generateArrow(mouseDownGenerateArrowFeatures);
        } else if (type === MOUSE_EVENTS.MOVE) {
            if (!UploadFileMarkupService.isDrawingArrow) {
                return;
            } //for move
            if (UploadFileMarkupService.isDrawingArrow) {
                console.log("move");
                UploadFileMarkupService.pointer = annCanvas.getPointer(o.e);
                annCanvas.remove(UploadFileMarkupService.arrowObj);
                let mouseMoveGenerateArrowFeatures = {
                    fromx: UploadFileMarkupService.origX,
                    fromy: UploadFileMarkupService.origY,
                    tox: UploadFileMarkupService.pointer.x,
                    toy: UploadFileMarkupService.pointer.y,
                    color: COLOR_TO_ANNOT[reduxStore.getState().markup.selectedColorIndex],
                    strokeWidth: reduxStore.getState().markup.selectedThicknessForShape,
                    isShadow: reduxStore.getState().markup.isShadowOrStroke,
                };
                UploadFileMarkupService.arrowObj = generateArrow(mouseMoveGenerateArrowFeatures);

                annCanvas.add(UploadFileMarkupService.arrowObj).setActiveObject(UploadFileMarkupService.arrowObj);
                annCanvas.renderAll();
            }
        } else if (type === MOUSE_EVENTS.UP) {
            //if mouse up after moving
            if (UploadFileMarkupService.isMovingArrow) {
                console.log("move up");
                //get moved object's new properties
                let arrows = annCanvas.getActiveObject();
                console.log(arrows);
                UploadFileMarkupService.isMovingRect = false;
                UploadFileMarkupService.changeMarkupShapeList(arrows);
                UploadFileMarkupService.addShapeCountLog(shapeStatus.MOVE);
            }
            //if mouse up after drawing
            if (UploadFileMarkupService.isDrawingArrow) {
                console.log("mouse up");
                UploadFileMarkupService.pointer = annCanvas.getPointer(o.e);
                const minimumArrowSizeVar = minimumArrowSize(reduxStore.getState().markup.selectedThicknessForShape);
                if (
                    Math.abs(UploadFileMarkupService.origX - UploadFileMarkupService.pointer.x) >= minimumArrowSizeVar ||
                    Math.abs(UploadFileMarkupService.origY - UploadFileMarkupService.pointer.y) >= minimumArrowSizeVar
                ) {
                    UploadFileMarkupService.handleShapeCount(1);
                    const dateTime = new Date();
                    UploadFileMarkupService.currTimeStamp = dateTime.getTime();
                    const group = UploadFileMarkupService.arrowObj;
                    group.set("id", UploadFileMarkupService.currTimeStamp);
                    group.set("localshape", true);
                    group.set("selectable", true);
                    annCanvas.remove(UploadFileMarkupService.arrowObj); // removing old object
                    annCanvas.add(group).setActiveObject(group); // add grouping object
                    addInShapeList(group);
                    UploadFileMarkupService.isDrawingArrow = false;
                    UploadFileMarkupService.addShapeCountLog(shapeStatus.DRAW);
                } else {
                    annCanvas.remove(UploadFileMarkupService.arrowObj); // removing old object
                    UploadFileMarkupService.isDrawingArrow = false;
                }
            }
        }
    };
}

export default new ArrowShapeService();
